// extracted by mini-css-extract-plugin
export default {"tableMe":"MachineElement_tableMe__kZyp5"};